"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var result = {};
var index = 0; // account.svg

result['account'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M5.973 8.854a3.5 3.5 0 1 1 4.041.01 5.226 5.226 0 0 1 3.267 3.731 7 7 0 1 0-10.627-.077c.412-1.725 1.668-3.06 3.319-3.664zm6.43 4.588C12.207 11.161 10.35 9.5 8 9.5c-2.354 0-4.28 1.601-4.475 3.883A6.972 6.972 0 0 0 8 15a6.97 6.97 0 0 0 4.403-1.558zM8 8.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z",
    fill: "currentColor"
  }));
}; // arrow-left.svg


result['arrow-left'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    d: "M6.25 9h6.78V7H6.25L8.5 4H6L3 8l3 4h2.5L6.25 9z",
    fill: "#FFF"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    d: "M6.25 9h6.78V7H6.25L8.5 4H6L3 8l3 4h2.5L6.25 9z",
    fill: "#FFF"
  })));
}; // arrow-right.svg


result['arrow-right'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    d: "M9.78 9H3V7h6.78L7.53 4h2.5l3 4-3 4h-2.5l2.25-3z",
    fill: "#FFF"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    d: "M9.78 9H3V7h6.78L7.53 4h2.5l3 4-3 4h-2.5l2.25-3z",
    fill: "#FFF"
  })));
}; // chart.svg


result['chart'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M1.5 14h13a.5.5 0 1 1 0 1h-13a.5.5 0 1 1 0-1zM2 5v7h2V5H2zm0-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1zm5-2v10h2V2H7zm0-1h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm5 6v5h2V7h-2zm0-1h2a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
    fill: "currentColor"
  }));
}; // check-circle.svg


result['check-circle'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm-.879-6.065l3.89-3.889a.5.5 0 0 1 .706.707l-4.242 4.243a.5.5 0 0 1-.732-.026.507.507 0 0 1-.026-.025L3.889 8.117a.5.5 0 0 1 .707-.707L7.12 9.935z",
    fill: "currentColor"
  }));
}; // check-square.svg


result['check-square'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("rect", {
    fill: "currentColor",
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: "1"
  }), _react["default"].createElement("path", {
    d: "M6.94 8.824l4.242-4.243 1.414 1.414-4.242 4.243-1.415 1.414-3.535-3.536 1.414-1.414 2.121 2.122z",
    fill: "#FFF"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("rect", {
    fill: "currentColor",
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: "1"
  }), _react["default"].createElement("path", {
    d: "M6.94 8.824l4.242-4.243 1.414 1.414-4.242 4.243-1.415 1.414-3.535-3.536 1.414-1.414 2.121 2.122z",
    fill: "#FFF"
  })));
}; // check.svg


result['check'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "currentColor"
  }, _react["default"].createElement("circle", {
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    d: "M7.243 9.502l4.95-4.95 1.414 1.414-4.95 4.95-1.414 1.414L3 8.088l1.414-1.415 2.829 2.829z",
    fill: "#FFF"
  })));
}; // close.svg


result['close'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9.414 8l2.829 2.828-1.415 1.415L8 9.414l-2.828 2.829-1.415-1.415L6.586 8 3.757 5.172l1.415-1.415L8 6.586l2.828-2.829 1.415 1.415z"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9.414 8l2.829 2.828-1.415 1.415L8 9.414l-2.828 2.829-1.415-1.415L6.586 8 3.757 5.172l1.415-1.415L8 6.586l2.828-2.829 1.415 1.415z"
  })));
}; // collection.svg


result['collection'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M11.757 1c-1.61 0-3.016.917-3.752 2.26A4.285 4.285 0 0 0 4.243 1C1.897 1 0 2.908 0 5.264c0 1.12.426 2.132 1.13 2.9l6.513 6.544c.107.096.234.15.362.15a.546.546 0 0 0 .363-.15l6.513-6.545A4.288 4.288 0 0 0 16 5.263C16 2.909 14.103 1 11.757 1zm2.314 6.47l-6.066 6.162L1.94 7.47a3.204 3.204 0 0 1-.874-2.206 3.189 3.189 0 0 1 3.177-3.198c1.417 0 2.643.938 3.07 2.228.106.277.383.48.692.48a.76.76 0 0 0 .704-.47 3.213 3.213 0 0 1 3.048-2.238 3.182 3.182 0 0 1 3.177 3.198c.01.853-.32 1.63-.863 2.206z",
    fill: "currentColor"
  }));
}; // copy.svg


result['copy'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M2 4v11h9V4H2zm0-1h9a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm4.5-3h7.49c.553 0 1 .383 1 .856v7.547A.45.45 0 0 1 15 8.5v2a.5.5 0 1 1-1 0v-.552h-.01V1H6.5a.5.5 0 0 1 0-1z",
    fill: "currentColor"
  }));
}; // cross.svg


result['cross'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8.5 7.5H15a.5.5 0 1 1 0 1H8.5V15a.5.5 0 1 1-1 0V8.5H1a.5.5 0 0 1 0-1h6.5V1a.5.5 0 0 1 1 0v6.5z",
    fill: "currentColor"
  }));
}; // crowd.svg


result['crowd'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("g", {
    transform: "translate(1 1)",
    stroke: "currentColor"
  }, _react["default"].createElement("circle", {
    cx: "9",
    cy: "4",
    r: "3"
  }), _react["default"].createElement("path", {
    d: "M6.035.183a3 3 0 0 0-1.413 5.793",
    strokeLinecap: "round"
  }), _react["default"].createElement("path", {
    d: "M14 12a5 5 0 0 0-10 0c0 2.761 10 2.761 10 0z"
  }), _react["default"].createElement("path", {
    d: "M4.532 6.022A5 5 0 0 0 0 11c0 .854.956 1.443 2.276 1.77",
    strokeLinecap: "round"
  })), _react["default"].createElement("path", {
    d: "M5.8 7.444a.498.498 0 0 1-.222.075A4.5 4.5 0 0 0 1.5 12c0 .496.663.98 1.896 1.284a.5.5 0 1 1-.24.97C1.526 13.853.5 13.105.5 12a5.504 5.504 0 0 1 3.501-5.126A3.501 3.501 0 0 1 7.208.714a.5.5 0 1 1-.345.939A2.5 2.5 0 0 0 5.685 6.48a.5.5 0 0 1 .115.963zm2.202.43a3.5 3.5 0 1 1 3.996 0A5.502 5.502 0 0 1 15.5 13c0 3.428-11 3.428-11 0a5.502 5.502 0 0 1 3.502-5.126zM10 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm4.5 5.5a4.5 4.5 0 1 0-9 0c0 2.095 9 2.095 9 0z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
}; // dashboard.svg


result['dashboard'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M9.982 9.477a2.5 2.5 0 1 1-.757-.656l1.293-1.339a.5.5 0 0 1 .72.695l-1.256 1.3zM8 0c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8 3.6-8 8-8zm0 15c3.9 0 7-3.1 7-7s-3.1-7-7-7-7 3.1-7 7 3.1 7 7 7zM8 2.5c3 0 5.5 2.5 5.5 5.5 0 .3-.2.5-.5.5s-.5-.2-.5-.5c0-2.5-2-4.5-4.5-4.5S3.5 5.5 3.5 8c0 .3-.2.5-.5.5s-.5-.2-.5-.5C2.5 5 5 2.5 8 2.5zm0 10a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "currentColor"
  }));
}; // data.svg


result['data'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M1.096 3.132L6.896.74C7.53.478 8.49.478 9.123.739l5.8 2.393c.924.38.923 1.305 0 1.685l-5.8 2.394c-.632.261-1.593.261-2.225 0L1.096 4.818c-.923-.381-.922-1.305 0-1.686zm.58.843l5.602 2.312c.388.16 1.074.16 1.463 0l5.602-2.312-5.602-2.312c-.388-.16-1.075-.16-1.463 0L1.675 3.975zm-.87 4.486a.5.5 0 0 1 .386-.922l6.046 2.524c.386.162 1.08.163 1.46.006l6.105-2.53a.5.5 0 1 1 .382.923l-6.105 2.53c-.625.26-1.596.258-2.228-.006L.807 8.461zm0 4a.5.5 0 1 1 .386-.922l6.046 2.524c.386.162 1.08.163 1.46.006l6.105-2.53a.5.5 0 1 1 .382.923l-6.105 2.53c-.625.26-1.596.258-2.228-.006L.807 12.461z",
    fill: "currentColor"
  }));
}; // date.svg


result['date'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M12 2.75v.467a.5.5 0 1 1-1 0V2.75H5v.467a.5.5 0 0 1-1 0V2.75H1.75V5h12.5V2.75H12zm0-1h2.253c.547 0 .997.444.997.993v11.514a.998.998 0 0 1-.997.993H1.747a.997.997 0 0 1-.997-.993V2.743c0-.544.446-.993.997-.993H4V1a.5.5 0 0 1 1 0v.75h6V1a.5.5 0 1 1 1 0v.75zM14.25 6H1.75v8.25h12.5V6zM4.235 9a.5.5 0 1 1 0-1h7.544a.5.5 0 1 1 0 1H4.235zm0 3a.5.5 0 1 1 0-1h7.544a.5.5 0 1 1 0 1H4.235z",
    fill: "currentColor"
  }));
}; // delete.svg


result['delete'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M14 15.144c0 .473-.448.856-1 .856H3c-.552 0-1-.383-1-.856v-5.105l1 .001V15h10V5.5a.5.5 0 1 1 1 0V10c0 .018 0 .035-.003.052L14 15.144zm-.5-4.644a.5.5 0 0 0 .497-.448L14 15.144c0 .473-.448.856-1 .856H3c-.552 0-1-.383-1-.856V10l.01-4.5a.5.5 0 0 1 1 0L3 10c0 .014 0 .027-.002.04L3 15h10v-4.948a.505.505 0 0 0 .5.448zM1.5 2h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm3-2h7a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1zM13 15.144V15c.031 0 0 .027 0 .144zm-10 0V15c-.031 0 0 .027 0 .144zm0 0V15c-.031 0 0 .027 0 .144zm10 0c0-.117.031-.144 0-.144v.144zM6.5 6a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .5-.5zm3 0a.5.5 0 0 1 .5.5v5a.5.5 0 1 1-1 0v-5a.5.5 0 0 1 .5-.5z",
    fill: "currentColor"
  }));
}; // download-center.svg


result['download-center'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M2 2v12h12V2H2zm0-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm6.501 9.431l2.179-1.815a.5.5 0 1 1 .64.768l-3 2.5a.5.5 0 0 1-.64 0l-3-2.5a.5.5 0 1 1 .64-.768l2.181 1.818V5a.5.5 0 0 1 1 0v5.431z",
    fill: "currentColor"
  }));
}; // download.svg


result['download'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8.501 10.825l4.409-3.527a.5.5 0 1 1 .625.781l-5.223 4.178a.5.5 0 0 1-.624 0L2.465 8.08a.5.5 0 0 1 .625-.78l4.411 3.528V1.545c0-.301.224-.545.5-.545s.5.244.5.545v9.28zM1.5 14h13a.5.5 0 1 1 0 1h-13a.5.5 0 1 1 0-1z",
    fill: "currentColor"
  }));
}; // downward.svg


result['downward'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16"
  }, props), _react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("polygon", {
    id: "Line-4",
    fill: "currentColor",
    points: "8.20710678 9.5 3.70710678 5 3 5.70710678 8.20710678 10.9142136 13.4142136 5.70710678 12.7071068 5"
  })));
}; // edit.svg


result['edit'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M13 14V6.5a.5.5 0 1 1 1 0V14a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6.5a.5.5 0 0 1 0 1H2v12h11zm1.132-12.646a.5.5 0 0 1 0 .707L7.06 9.13a.5.5 0 1 1-.707-.706l7.07-7.071a.5.5 0 0 1 .708 0z",
    fill: "currentColor"
  }));
}; // effect.svg


result['effect'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M7.205 2.139a4.8 4.8 0 1 1 6.657 6.657 6.933 6.933 0 1 1-6.657-6.657zm1.226.157a6.943 6.943 0 0 1 5.273 5.273 3.733 3.733 0 1 0-5.273-5.273zm-1.76.91a5.867 5.867 0 1 0 6.123 6.123 4.8 4.8 0 0 1-6.123-6.123zm1.126.057a3.733 3.733 0 0 0 4.94 4.94 5.87 5.87 0 0 0-4.94-4.94z",
    fill: "currentColor"
  }));
}; // enterprise.svg


result['enterprise'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M9 12V2H2v10h7zm1 0h4V7h-4v5zm3.8 1H2.125C1.504 13 1 12.552 1 12V2c0-.552.504-1 1.125-1h6.75C9.496 1 10 1.448 10 2v4.014c.065-.01.132-.014.2-.014h3.6c.663 0 1.2.448 1.2 1v5c0 .552-.537 1-1.2 1zM1.5 14h13a.5.5 0 1 1 0 1h-13a.5.5 0 1 1 0-1zm2-10h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1zm0 3h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1 0-1z",
    fill: "currentColor"
  }));
}; // exclamation.svg


result['exclamation'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = 'spaui-icon-exclamation-' + index++;
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("defs", null, _react["default"].createElement("circle", {
    id: id,
    cx: "8",
    cy: "8",
    r: "8"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("mask", {
    id: id + '-b',
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: '#' + id
  })), _react["default"].createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: '#' + id
  }), _react["default"].createElement("path", {
    d: "M7 3h2v6.5H7V3zm0 8h2v2H7v-2z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: 'url(#' + id + '-b)'
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("defs", null, _react["default"].createElement("circle", {
    id: id,
    cx: "8",
    cy: "8",
    r: "8"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("mask", {
    id: id + '-b',
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: '#' + id
  })), _react["default"].createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: '#' + id
  }), _react["default"].createElement("path", {
    d: "M7 3h2v6.5H7V3zm0 8h2v2H7v-2z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: 'url(#' + id + '-b)'
  })));
}; // file.svg


result['file'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M9.614 1.778V4.47a.5.5 0 0 0 .5.5h2.692L9.614 1.778zm-1-.528H3c-.248 0-.5.252-.5.5v12.5c0 .248.252.5.5.5h10c.248 0 .5-.252.5-.5V5.97h-3.386a1.5 1.5 0 0 1-1.5-1.5V1.25zm-7.114.5c0-.8.7-1.5 1.5-1.5h6.5l5 5v9c0 .8-.7 1.5-1.5 1.5H3c-.8 0-1.5-.7-1.5-1.5V1.75z",
    fill: "currentColor"
  }));
}; // flow.svg


result['flow'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M14.98 8.529h-2.56l-1.252 1.353a.5.5 0 0 1-.82-.13L8.734 6.269l-1.67 4.216a.5.5 0 0 1-.876.1L4.444 8.069l-.977 1.057a.5.5 0 0 1-.367.16H1.118A7.002 7.002 0 0 0 14.98 8.53zm.004-1a7 7 0 0 0-13.978.757H2.88l1.252-1.354a.5.5 0 0 1 .778.055l1.568 2.261 1.756-4.432a.5.5 0 0 1 .919-.026l1.786 3.865.893-.966a.5.5 0 0 1 .367-.16h2.784zM8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16z",
    fill: "currentColor"
  }));
}; // form.svg


result['form'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M5 2H2v3h3V2zm1 0v3h8V2H6zM5 14V6H2v8h3zm1 0h8V6H6v8zM2 1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z",
    fill: "currentColor"
  }));
}; // from-authorization.svg


result['from-authorization'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8 8.682V10.5a.5.5 0 1 1-1 0v-3a.5.5 0 0 1 .5-.5h3a.5.5 0 1 1 0 1H8.732l5.432 5.431a.5.5 0 0 1-.708.707L8 8.682zm6-.182V2H2v12h6.5a.5.5 0 1 1 0 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6.5a.5.5 0 1 1-1 0z",
    fill: "currentColor"
  }));
}; // group.svg


result['group'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M6 9H2v5h12V5H2v3h4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h4v1h-4a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1zM3.968 4a4.5 4.5 0 0 1 8.064 0H14a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h1.968zm1.159 0h5.746a3.5 3.5 0 0 0-5.746 0zM7 8v1h2V8H7z",
    fill: "currentColor"
  }));
}; // home.svg


result['home'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M10.824 15.063h1.88a.468.468 0 0 0 .472-.465v-9.15L8 2.03 2.824 5.447v9.15c0 .254.214.466.472.466h1.88V11.78A2.818 2.818 0 0 1 8 8.97a2.818 2.818 0 0 1 2.824 2.812v3.281zm-.942 0V11.78A1.879 1.879 0 0 0 8 9.906c-1.04 0-1.882.84-1.882 1.875v3.281h3.764zm-8-8.995l-1.151.76a.472.472 0 0 1-.653-.132.468.468 0 0 1 .133-.65l7.53-4.968a.472.472 0 0 1 .519 0l7.53 4.969a.468.468 0 0 1 .132.65.472.472 0 0 1-.653.131l-1.151-.76v8.53c0 .776-.634 1.402-1.414 1.402H3.296a1.412 1.412 0 0 1-1.414-1.402v-8.53z",
    fill: "currentColor"
  }));
}; // income.svg


result['income'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M7 12.376c-.602-.184-1.137-.533-1.604-1a4.585 4.585 0 0 1-.845-1.134.5.5 0 1 1 .894-.447 4.04 4.04 0 0 0 .658.873c.54.54 1.171.857 1.9.857 1.587 0 2.505-.69 2.505-1.506 0-.816-.918-1.506-2.505-1.506-2.086 0-3.505-1.066-3.505-2.507 0-1.195.977-2.133 2.502-2.417V3a.5.5 0 0 1 1 0v.5h.003c1.024 0 1.895.436 2.608 1.15.419.42.697.838.845 1.133a.5.5 0 0 1-.895.447 4.04 4.04 0 0 0-.658-.873c-.54-.54-1.17-.857-1.9-.857-1.586 0-2.505.69-2.505 1.506 0 .816.919 1.507 2.505 1.507 2.087 0 3.505 1.065 3.505 2.506 0 1.44-1.418 2.506-3.505 2.506H8V13a.5.5 0 1 1-1 0v-.624zM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z",
    fill: "currentColor"
  }));
}; // info.svg


result['info'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = 'spaui-icon-info-' + index++;
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("defs", null, _react["default"].createElement("circle", {
    id: id,
    cx: "8",
    cy: "8",
    r: "8"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("mask", {
    id: id + '-b',
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: '#' + id
  })), _react["default"].createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: '#' + id
  }), _react["default"].createElement("path", {
    d: "M7 3h2v6.5H7V3zm0 8h2v2H7v-2z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: 'url(#' + id + '-b)',
    transform: "matrix(1 0 0 -1 0 16)"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("defs", null, _react["default"].createElement("circle", {
    id: id,
    cx: "8",
    cy: "8",
    r: "8"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("mask", {
    id: id + '-b',
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: '#' + id
  })), _react["default"].createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: '#' + id
  }), _react["default"].createElement("path", {
    d: "M7 3h2v6.5H7V3zm0 8h2v2H7v-2z",
    fill: "#FFF",
    fillRule: "nonzero",
    mask: 'url(#' + id + '-b)',
    transform: "matrix(1 0 0 -1 0 16)"
  })));
}; // label.svg


result['label'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M7.704 1.97L1.583 7.99l6.31 6.31 6.111-6.112V1.971h-6.3zm0-1h6.3a1 1 0 0 1 1 1v6.217a1 1 0 0 1-.293.707L8.6 15.006a1 1 0 0 1-1.415 0l-6.31-6.31a1 1 0 0 1 .007-1.42l6.12-6.018A1 1 0 0 1 7.705.97zm1.944 5.306a2 2 0 1 1 2.829-2.828 2 2 0 0 1-2.829 2.828zm.708-.707a1 1 0 1 0 1.414-1.414 1 1 0 0 0-1.414 1.414z",
    fill: "currentColor"
  }));
}; // link.svg


result['link'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M7.605 4.246a.533.533 0 0 1 0-.754l1.428-1.427C10.428.669 12.74.72 14.199 2.178c1.458 1.458 1.509 3.771.113 5.166L12.147 9.51c-1.395 1.395-3.708 1.344-5.166-.114a.533.533 0 0 1 0-.754l.014-.014a.468.468 0 0 1 .673.01l.034.037c1.042 1.041 2.694 1.077 3.69.08l2.166-2.165c.997-.996.96-2.649-.08-3.69-1.042-1.041-2.694-1.078-3.691-.081L8.359 4.246a.533.533 0 0 1-.754 0zm.79 7.508a.533.533 0 0 1 0 .754l-1.428 1.427c-1.395 1.396-3.708 1.345-5.166-.113C.343 12.364.292 10.05 1.688 8.656L3.853 6.49c1.395-1.395 3.708-1.344 5.166.114a.533.533 0 0 1 0 .754l-.014.014a.468.468 0 0 1-.673-.01 1.463 1.463 0 0 0-.034-.037c-1.042-1.041-2.694-1.077-3.69-.08L2.441 9.41c-.997.996-.96 2.649.08 3.69 1.042 1.041 2.694 1.078 3.691.081l1.428-1.427a.533.533 0 0 1 .754 0z",
    fill: "currentColor"
  }));
}; // mailbox.svg


result['mailbox'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M15 12.266v-8.58l-4.602 3.926L15 12.266zm-.68.734L9.634 8.263l-.66.562a1.5 1.5 0 0 1-1.95-.002l-.604-.518L1.705 13H14.32zm-.056-10H1.773l5.903 5.064a.5.5 0 0 0 .65 0L14.264 3zM1 3.654v8.637l4.66-4.64L1 3.655zM1 2h14a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1z",
    fill: "currentColor"
  }));
}; // marketing-application.svg


result['marketing-application'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8.626 5.355a.5.5 0 1 1 .703-.71l2.012 1.992a.5.5 0 0 1-.352.855H5a.5.5 0 1 1 0-1h4.773L8.626 5.355zm-1.262 5.282a.5.5 0 0 1-.704.71L4.65 9.355A.5.5 0 0 1 5 8.5h5.989a.5.5 0 1 1 0 1H6.216l1.148 1.137zM2 2v12h12V2H2zm0-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z",
    fill: "currentColor"
  }));
}; // minus-square.svg


result['minus-square'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("rect", {
    fill: "currentColor",
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: "1"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2h-9V7H7z"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("rect", {
    fill: "currentColor",
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: "1"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2h-9V7H7z"
  })));
}; // minus.svg


result['minus'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2h-9V7H7z"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2h-9V7H7z"
  })));
}; // model.svg


result['model'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M15 8.062L11.5 2h-7L1 8.062l3.5 6.062h7L15 8.062zm.866.5l-3.5 6.062a1 1 0 0 1-.866.5h-7a1 1 0 0 1-.866-.5l-3.5-6.062a1 1 0 0 1 0-1l3.5-6.062A1 1 0 0 1 4.5 1h7a1 1 0 0 1 .866.5l3.5 6.062a1 1 0 0 1 0 1zm-11.366-1h7a.5.5 0 1 1 0 1h-7a.5.5 0 0 1 0-1zm2-3h3a.5.5 0 1 1 0 1h-3a.5.5 0 0 1 0-1zm0 6h3a.5.5 0 0 1 0 1h-3a.5.5 0 1 1 0-1z",
    fill: "currentColor"
  }));
}; // operation-authorization.svg


result['operation-authorization'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M6.644 8.55a.498.498 0 0 1-.23.081 5.424 5.424 0 0 0-4.914 5.4.5.5 0 1 1-1 0 6.428 6.428 0 0 1 4.257-6.05A4.056 4.056 0 0 1 8.322.749a.5.5 0 1 1-.345.939 3.054 3.054 0 0 0-1.44 5.897.5.5 0 0 1 .107.966zm3.222.496A4 4 0 0 1 11.717 1.5a4 4 0 0 1 1.811 7.568 6.398 6.398 0 0 1 2.004 1.021.5.5 0 0 1-.603.798 5.423 5.423 0 0 0-8.69 4.328.5.5 0 1 1-1 0 6.426 6.426 0 0 1 4.627-6.169zm1.851-.546a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-1.035 5.53h4.086a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.147-.021.5.5 0 0 1-.5-.832l2.122-2.121a.5.5 0 0 1 .707.707l-1.268 1.267z",
    fill: "currentColor"
  }));
}; // phone.svg


result['phone'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M6.925 9.075l-.354.353c2.06 2.058 3.446 2.96 4.331 2.078l.26-.263a7.35 7.35 0 0 1 .23-.225c.632-.584 1.072-.566 2.313.432.65.522.852.929.782 1.29-.06.305-.293.617-.785 1.093a46.67 46.67 0 0 0-.453.435c-.912.912-4.639-.493-7.832-3.686C2.225 7.388.82 3.662 1.732 2.75c.098-.098.454-.471.435-.452.475-.492.788-.726 1.093-.785.362-.07.768.133 1.29.783.998 1.24 1.015 1.681.432 2.313a6.3 6.3 0 0 1-.225.23l-.26.259c-.887.884.018 2.277 2.074 4.33l.354-.353zm0 0l.353-.354C5.76 7.204 4.988 6.019 5.203 5.805l.258-.256c.105-.103.183-.183.256-.262.943-1.02.902-2.013-.387-3.617C4.596.756 3.844.38 3.07.532c-.572.11-1.01.438-1.623 1.072.011-.012-.334.35-.423.44C-.43 3.5 1.172 7.75 4.71 11.288c3.54 3.539 7.79 5.142 9.246 3.686.089-.088.454-.437.44-.423.634-.612.961-1.05 1.072-1.621.15-.774-.223-1.526-1.136-2.26-1.605-1.29-2.598-1.331-3.618-.387a8.26 8.26 0 0 0-.263.255l-.255.259c-.214.212-1.396-.557-2.918-2.077l-.353.354z",
    fill: "currentColor"
  }));
}; // picture.svg


result['picture'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M7.27 10.211c1.046-.542 3.134-1.925 3.454-2.073.967-.448 1.914-.42 3.776.151V2h-13v7.042c2.242 1.986 3.466 2.36 5.77 1.17zM1.5 14h13V9.337c-1.84-.591-2.615-.635-3.355-.292-.235.109-2.298 1.476-3.416 2.054-2.456 1.27-3.89 1.004-6.229-.765V14zm0-13h13a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-13a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm4 7.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5zm0-1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z",
    fill: "currentColor"
  }));
}; // plus-box.svg


result['plus-box'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M7.501 7.5V3.998a.5.5 0 0 1 1 0V7.5H12a.5.5 0 1 1 0 1H8.501v3.508a.5.5 0 1 1-1 0V8.5H4a.5.5 0 0 1 0-1h3.501zM2 2v12h12V2H2zm0-1h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z",
    fill: "currentColor"
  }));
}; // plus-square.svg


result['plus-square'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("rect", {
    fill: "currentColor",
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: "1"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2H9v3.5H7V9H3.5V7H7V3.5h2z"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("rect", {
    fill: "currentColor",
    x: "1",
    y: "1",
    width: "14",
    height: "14",
    rx: "1"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2H9v3.5H7V9H3.5V7H7V3.5h2z"
  })));
}; // plus.svg


result['plus'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2H9v3.5H7V9H3.5V7H7V3.5h2z"
  }))) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none"
  }, _react["default"].createElement("circle", {
    fill: "currentColor",
    cx: "8",
    cy: "8",
    r: "8"
  }), _react["default"].createElement("path", {
    fill: "#FFF",
    d: "M9 7h3.5v2H9v3.5H7V9H3.5V7H7V3.5h2z"
  })));
}; // question.svg


result['question'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = 'spaui-icon-question-' + index++;
  return props.solid || false ? _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
    fill: "currentColor",
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8.571 1.714c0-.233.243-.416 1.143-1.143.823-.664 1.715-1.196 1.715-2.571 0-1.011-.367-1.803-1.005-2.319-.65-.526-1.399-.824-2.424-.824-1.21 0-2.14.4-2.784 1.073-.74.773-.645 1.6-.645 2.356h1.715v-.32c0-.321.064-.808.571-1.142.245-.161.692-.248 1.144-.253.436-.004.874.069 1.142.253.537.371.571.77.571 1.176 0 .443-.384.872-1.143 1.429-1.15.843-1.714 1.163-1.714 1.714v1.422h1.717s-.003-.563-.003-.85zm-1.857 3.429h2v-1.714h-2v1.714z",
    id: id
  })), _react["default"].createElement("use", {
    fill: "currentColor",
    xlinkHref: '#' + id
  })) : _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
    d: "M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8.571 1.714c0-.233.243-.416 1.143-1.143.823-.664 1.715-1.196 1.715-2.571 0-1.011-.367-1.803-1.005-2.319-.65-.526-1.399-.824-2.424-.824-1.21 0-2.14.4-2.784 1.073-.74.773-.645 1.6-.645 2.356h1.715v-.32c0-.321.064-.808.571-1.142.245-.161.692-.248 1.144-.253.436-.004.874.069 1.142.253.537.371.571.77.571 1.176 0 .443-.384.872-1.143 1.429-1.15.843-1.714 1.163-1.714 1.714v1.422h1.717s-.003-.563-.003-.85zm-1.857 3.429h2v-1.714h-2v1.714z",
    id: id
  })), _react["default"].createElement("use", {
    xlinkHref: '#' + id
  }));
}; // save-selected.svg


result['save-selected'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, props), " xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>", _react["default"].createElement("g", {
    id: "icon/\u901A\u7528/\u5706\u89D2/\u53E6\u5B58\u6240\u9009\u5185\u5BB9",
    stroke: "none",
    strokeWidth: "1",
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M12,2 L12,5.5 C12,6.32842712 11.3284271,7 10.5,7 L5.5,7 C4.67157288,7 4,6.32842712 4,5.5 L4,2 L2,2 L2,14 L9.5,14 C9.77614237,14 10,14.2238576 10,14.5 C10,14.7761424 9.77614237,15 9.5,15 L2,15 C1.44771525,15 1,14.5522847 1,14 L1,2 C1,1.44771525 1.44771525,1 2,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,5.5 C15,5.77614237 14.7761424,6 14.5,6 C14.2238576,6 14,5.77614237 14,5.5 L14,2 L12,2 Z M11,2 L10,2 L10,4.5 C10,4.77614237 9.77614237,5 9.5,5 C9.22385763,5 9,4.77614237 9,4.5 L9,2 L5,2 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L10.5,6 C10.7761424,6 11,5.77614237 11,5.5 L11,2 Z M12,10 L12,8.5 C12,8.22385763 12.2238576,8 12.5,8 C12.7761424,8 13,8.22385763 13,8.5 L13,10 L14.5,10 C14.7761424,10 15,10.2238576 15,10.5 C15,10.7761424 14.7761424,11 14.5,11 L13,11 L13,12.5 C13,12.7761424 12.7761424,13 12.5,13 C12.2238576,13 12,12.7761424 12,12.5 L12,11 L10.5,11 C10.2238576,11 10,10.7761424 10,10.5 C10,10.2238576 10.2238576,10 10.5,10 L12,10 Z",
    id: "\u5F62\u72B6",
    fill: "currentColor"
  })));
}; // save.svg


result['save'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, props), ">", _react["default"].createElement("g", {
    id: "icon/\u901A\u7528/\u5706\u89D2/\u4FDD\u5B58",
    stroke: "none",
    strokeWidth: "1",
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M4,2 L2,2 L2,14 L14,14 L14,2 L12,2 L12,5.5 C12,6.32842712 11.3284271,7 10.5,7 L5.5,7 C4.67157288,7 4,6.32842712 4,5.5 L4,2 Z M2,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,14 C15,14.5522847 14.5522847,15 14,15 L2,15 C1.44771525,15 1,14.5522847 1,14 L1,2 C1,1.44771525 1.44771525,1 2,1 Z M9,2 L5,2 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L10.5,6 C10.7761424,6 11,5.77614237 11,5.5 L11,2 L10,2 L10,4.5 C10,4.77614237 9.77614237,5 9.5,5 C9.22385763,5 9,4.77614237 9,4.5 L9,2 Z",
    id: "\u5F62\u72B6",
    fill: "currentColor"
  })));
}; // saveas-copy.svg


result['saveas-copy'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, props), ">", _react["default"].createElement("g", {
    id: "icon/\u901A\u7528/\u5706\u89D2/\u53E6\u5B58\u4E3A\u526F\u672C",
    stroke: "none",
    strokeWidth: "1",
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M13,3 L13,2 L2,2 L2,13 L3,13 L3,4 C3,3.44771525 3.44771525,3 4,3 L13,3 Z M14,3 C14.5522847,3 15,3.44771525 15,4 L15,14 C15,14.5522847 14.5522847,15 14,15 L4,15 C3.44771525,15 3,14.5522847 3,14 L2,14 C1.44771525,14 1,13.5522847 1,13 L1,2 C1,1.44771525 1.44771525,1 2,1 L13,1 C13.5522847,1 14,1.44771525 14,2 L14,3 Z M5,4 L4,4 L4,14 L14,14 L14,4 L13,4 L13,6.5 C13,7.32842712 12.3284271,8 11.5,8 L6.5,8 C5.67157288,8 5,7.32842712 5,6.5 L5,4 Z M10,4 L6,4 L6,6.5 C6,6.77614237 6.22385763,7 6.5,7 L11.5,7 C11.7761424,7 12,6.77614237 12,6.5 L12,4 L11,4 L11,5.5 C11,5.77614237 10.7761424,6 10.5,6 C10.2238576,6 10,5.77614237 10,5.5 L10,4 Z",
    id: "\u5F62\u72B6",
    fill: "currentColor"
  })));
}; // saveas.svg


result['saveas'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    version: "1.1"
  }, props), ">", _react["default"].createElement("g", {
    id: "icon/\u901A\u7528/\u5706\u89D2/\u53E6\u5B58\u4E3A",
    stroke: "none",
    strokeWidth: "1",
    fill: "currentColor",
    fillRule: "evenodd"
  }, _react["default"].createElement("path", {
    d: "M12,2 L12,5.5 C12,6.32842712 11.3284271,7 10.5,7 L5.5,7 C4.67157288,7 4,6.32842712 4,5.5 L4,2 L2,2 L2,14 L9.5,14 C9.77614237,14 10,14.2238576 10,14.5 C10,14.7761424 9.77614237,15 9.5,15 L2,15 C1.44771525,15 1,14.5522847 1,14 L1,2 C1,1.44771525 1.44771525,1 2,1 L14,1 C14.5522847,1 15,1.44771525 15,2 L15,5.5 C15,5.77614237 14.7761424,6 14.5,6 C14.2238576,6 14,5.77614237 14,5.5 L14,2 L12,2 Z M11,2 L10,2 L10,4.5 C10,4.77614237 9.77614237,5 9.5,5 C9.22385763,5 9,4.77614237 9,4.5 L9,2 L5,2 L5,5.5 C5,5.77614237 5.22385763,6 5.5,6 L10.5,6 C10.7761424,6 11,5.77614237 11,5.5 L11,2 Z M12.1204058,8.82010474 C11.9432031,8.60796629 11.9719333,8.29268394 12.1845766,8.1159019 C12.3972199,7.93911986 12.7132526,7.96778189 12.8904554,8.17992034 L14.8844129,10.1803229 C15.0392998,10.3657459 15.0392998,10.6350843 14.8844129,10.8205073 L12.8904554,12.8212358 C12.7132526,13.0333742 12.3972199,13.0620363 12.1845766,12.8852542 C11.9719333,12.7084722 11.9432031,12.3931898 12.1204058,12.1810514 L13.4303719,10.9991639 L8.501768,10.9991639 C8.22496844,10.9991639 8.00057806,10.7753063 8.00057806,10.4991639 C8.00057806,10.2230215 8.22496844,9.99916391 8.501768,9.99916391 L13.4282816,9.99916391 L12.1204058,8.82010474 Z",
    id: "\u5F62\u72B6",
    fill: "currentColor"
  })));
}; // search.svg


result['search'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M12.575 11.83l2.925 2.9a.5.5 0 1 1-.704.711l-2.921-2.896a6.933 6.933 0 1 1 .7-.714zm-5.29 1.45a5.933 5.933 0 1 0 0-11.866 5.933 5.933 0 0 0 0 11.867z",
    fill: "currentColor"
  }));
}; // sort.svg


result['sort'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M15.147 11.146a.5.5 0 0 1 .706.708l-3 2.989a.5.5 0 0 1-.853-.354V2.5a.5.5 0 1 1 1 0v10.785l2.147-2.14zM.5 3h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1 0-1zm0 5h9a.5.5 0 1 1 0 1h-9a.5.5 0 1 1 0-1z",
    fill: "currentColor"
  }));
}; // sound-off.svg


result['sound-off'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M3.996 3.346a4.67 4.67 0 0 0 .325-.192c.358-.228.86-.585 1.525-1.096A62.04 62.04 0 0 0 7.496.743 1.026 1.026 0 0 1 8.619.61c.358.18.581.55.58.953v12.875c0 .414-.234.792-.605.966a1.02 1.02 0 0 1-1.13-.177 50.53 50.53 0 0 0-1.481-1.311 19.155 19.155 0 0 0-1.362-1.078 4.053 4.053 0 0 0-.282-.183H.943A.953.953 0 0 1 0 11.69V4.31c0-.528.418-.963.943-.963H1.9l.047-.002h2.05zm2.46-.495c-1.23.944-1.888 1.362-2.193 1.468l-.163.027H1.962l-.047.002H1v7.306h3.452l.176.032c.298.112.903.534 2.001 1.467a51.506 51.506 0 0 1 1.511 1.338c.007.006.014.009.019.009a.02.02 0 0 0 .008-.002c.017-.008.031-.031.031-.06V1.56c0-.028-.013-.05-.029-.058-.008-.005-.016-.004-.026.003-.19.162-1.03.84-1.688 1.345zM14.071 8l1.768 1.767a.5.5 0 0 1-.707.707l-1.768-1.768-1.767 1.768a.5.5 0 1 1-.708-.707L12.658 8 10.89 6.232a.5.5 0 0 1 .708-.707l1.767 1.768 1.768-1.768a.5.5 0 0 1 .707.707L14.072 8z",
    fill: "currentColor"
  }));
}; // sound-on.svg


result['sound-on'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M4.496 3.346a4.67 4.67 0 0 0 .325-.192c.358-.228.86-.585 1.525-1.096A62.04 62.04 0 0 0 7.996.743 1.026 1.026 0 0 1 9.119.61c.358.18.581.55.58.953v12.875c0 .414-.234.792-.605.966a1.02 1.02 0 0 1-1.13-.177 50.53 50.53 0 0 0-1.481-1.311 19.155 19.155 0 0 0-1.362-1.078 4.053 4.053 0 0 0-.282-.183H1.443A.953.953 0 0 1 .5 11.69V4.31c0-.528.418-.963.943-.963H2.4l.047-.002h2.05zm2.46-.495c-1.23.944-1.888 1.362-2.193 1.468l-.163.027H2.462l-.047.002H1.5v7.306h3.452l.176.032c.298.112.903.534 2.001 1.467a51.506 51.506 0 0 1 1.511 1.338c.007.006.014.009.019.009a.02.02 0 0 0 .008-.002c.017-.008.031-.031.031-.06V1.56c0-.028-.013-.05-.029-.058-.008-.005-.016-.004-.026.003-.19.162-1.03.84-1.688 1.345zm4.891 7.56a.5.5 0 1 1-.682-.731c.505-.47.797-1.126.797-1.83a2.49 2.49 0 0 0-.802-1.834.5.5 0 1 1 .68-.734 3.491 3.491 0 0 1 1.122 2.568c0 .984-.41 1.904-1.115 2.561zm2.097 2.146a.5.5 0 0 1-.69-.724 5.482 5.482 0 0 0 1.708-3.983 5.482 5.482 0 0 0-1.712-3.988.5.5 0 1 1 .689-.724 6.482 6.482 0 0 1 2.023 4.712 6.482 6.482 0 0 1-2.018 4.707z",
    fill: "currentColor"
  }));
}; // spaui-icon-big-error.svg


result['spaui-icon-big-error'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var id = 'spaui-icon-spaui-icon-big-error-' + index++;
  return _react["default"].createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, _react["default"].createElement("defs", null, _react["default"].createElement("circle", {
    id: id,
    cx: "20",
    cy: "20",
    r: "20"
  })), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("mask", {
    id: id + '-b',
    fill: "#fff"
  }, _react["default"].createElement("use", {
    xlinkHref: '#' + id
  })), _react["default"].createElement("use", {
    fill: "#F64B4B",
    xlinkHref: '#' + id
  }), _react["default"].createElement("path", {
    d: "M12.5 12.5l15 15",
    stroke: "#FFF",
    strokeWidth: "4",
    strokeLinecap: "square",
    mask: 'url(#' + id + '-b)'
  }), _react["default"].createElement("path", {
    d: "M12.5 12.5l15 15",
    stroke: "#FFF",
    strokeWidth: "4",
    strokeLinecap: "square",
    mask: 'url(#' + id + '-b)',
    transform: "matrix(-1 0 0 1 40 0)"
  })));
}; // spaui-icon-big-remind.svg


result['spaui-icon-big-remind'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "#F9BA00"
  }), _react["default"].createElement("path", {
    d: "M20 11v10m0 8v-1",
    stroke: "#FFF",
    strokeWidth: "4",
    strokeLinecap: "square"
  })));
}; // spaui-icon-big-success.svg


result['spaui-icon-big-success'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    fill: "#42B847",
    cx: "20",
    cy: "20",
    r: "20"
  }), _react["default"].createElement("path", {
    d: "M9.481 17l8.019 8.25L30 12.75",
    stroke: "#FFF",
    strokeWidth: "4"
  })));
}; // spaui-icon-big-tip.svg


result['spaui-icon-big-tip'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20",
    fill: "#2096F5"
  }), _react["default"].createElement("path", {
    d: "M20 19v10m0-17v-1",
    stroke: "#FFF",
    strokeWidth: "4",
    strokeLinecap: "square"
  })));
}; // spaui-icon-big-warning.svg


result['spaui-icon-big-warning'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _react["default"].createElement("circle", {
    fill: "#F64B4B",
    cx: "20",
    cy: "20",
    r: "20"
  }), _react["default"].createElement("path", {
    d: "M20 11v10m0 8v-1",
    stroke: "#FFF",
    strokeWidth: "4",
    strokeLinecap: "square"
  })));
}; // time.svg


result['time'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8.5 8h4.009a.5.5 0 1 1 0 1H8a.5.5 0 0 1-.5-.527V3.5a.5.5 0 0 1 1 0V8zM8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z",
    fill: "currentColor"
  }));
}; // video-play.svg


result['video-play'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm3-8L6 5v6l5-3zm.537.808l-5.031 3.047a1.003 1.003 0 0 1-1.356-.303.931.931 0 0 1-.15-.505V4.953C5 4.427 5.44 4 5.984 4c.185 0 .365.05.522.145l5.031 3.047a.936.936 0 0 1 0 1.616z",
    fill: "currentColor"
  }));
}; // welfare.svg


result['welfare'] = function () {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _react["default"].createElement("svg", _extends({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _react["default"].createElement("title", null, props.title || ''), _react["default"].createElement("path", {
    d: "M4.41 5c-.852-.491-1.354-1.203-1.354-2.177C3.056 1.356 4.278.488 5.79.528c.905.024 1.715.366 2.209.94.494-.574 1.304-.916 2.21-.94 1.512-.04 2.734.828 2.734 2.295 0 .974-.502 1.686-1.355 2.177h2.404C14.55 5 15 5.448 15 6v3a1 1 0 0 1-1 1v4.997A.996.996 0 0 1 12.998 16H3.002A1.007 1.007 0 0 1 2 14.997V10c-.554-.004-1-.45-1-1V6a1 1 0 0 1 1.007-1H4.41zM7.5 2.823c0-.733-.737-1.27-1.735-1.295-1.007-.027-1.71.471-1.71 1.295 0 .818.66 1.377 1.859 1.715.454.129.946.212 1.438.258l.148.016V2.823zm1 0V4.81l.148-.013c.492-.046.984-.13 1.438-.258 1.199-.338 1.858-.897 1.858-1.715 0-.824-.702-1.322-1.709-1.295-.998.026-1.735.562-1.735 1.295zM7.513 9V6H2v3h5.513zm1 0H14V6H8.513v3zm-1 5.998v-4.997L3.003 10 3 14.997l4.513.001zm1 0l4.485.002.002-4.997-4.487-.001v4.997z",
    fill: "currentColor"
  }));
};

var _default = result;
exports["default"] = _default;